import * as Auth from "./Auth";
import * as ModifyWorkspaceUsers from "./ModifyWorkspaceUsers";
import * as ModifyWorkspacePlan from "./ModifyWorkspacePlan";
import * as AiGeneration from "./AiGeneration";
import * as PaymentMethod from "./PaymentMethod";
import * as SignupFlow from "./SignupFlow";
import * as SignupFlowMay2026 from "./SignupFlowMay2026";
import * as Dunning from "./Dunning";

import * as util from "./util";

const Analytics = {
    AiGeneration,
    Auth,
    ModifyWorkspacePlan,
    ModifyWorkspaceUsers,
    PaymentMethod,
    SignupFlow,
    SignupFlowMay2026,
    util,
    Dunning
};

export default Analytics;
